import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import React from 'react';

type LivePreviewAddonsTableProps = {
  rows: [React.ReactNode, React.ReactNode, ...React.ReactNode[]][];
};

export const LivePreviewAddonsTable: React.FC<LivePreviewAddonsTableProps> = ({ rows }) => {
  const largestRowLength = countLargestRowLength(rows);

  return (
    <>
      <TableContainer>
        <Table style={{
          tableLayout: 'fixed',
          borderTop: '1px solid #E1E6E8',
          borderBottom: '1px solid #E1E6E8',
        }}
        >
          <TableBody>
            {rows.map((row) => {
              const [firstCell, middleCells, lastCell] = getCells(largestRowLength, row);

              return (
                <TableRow
                  key={crypto.randomUUID()}
                  sx={{
                    '&:last-child td, &:last-child th': {
                      borderBottom: 0,
                    },
                    'td, th': {
                      position: 'relative',
                    },
                    'td:before, th:before': {
                      content: '""',
                      height: '12px',
                      width: '1px',
                      backgroundColor: '#E1E6E8',
                      position: 'absolute',
                      right: 0,
                      top: '8px',
                    },
                    'td:last-child:before': {
                      content: '""',
                      height: 0,
                      width: 0,
                      backgroundColor: 'transparent',
                      position: 'absolute',
                    },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    className="px-0 py-2 text-[10px] font-normal leading-3 text-[#576063]"
                  >
                    {firstCell}
                  </TableCell>

                  {middleCells.map(middleCell => (
                    <TableCell
                      key={crypto.randomUUID()}
                      className="px-0 py-2 text-[10px] font-light leading-3 text-[#606A6E]"
                      align="center"
                    >
                      {middleCell}
                    </TableCell>
                  ))}

                  <TableCell
                    className="px-0 py-2 text-[10px] font-light leading-3 text-[#606A6E]"
                    align="right"
                  >
                    {lastCell}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

function countLargestRowLength(rows: LivePreviewAddonsTableProps['rows']) {
  return rows.reduce((max, row) => Math.max(max, row.length), 0);
}

function getCells(largestRowLength: number, row: LivePreviewAddonsTableProps['rows'][0]) {
  const [firstCell, ...middleCells] = row;
  if (middleCells.length < largestRowLength - 1) {
    const amountOfNewCells = largestRowLength - 1 - middleCells.length;
    Array.from({ length: amountOfNewCells }).forEach(() => middleCells.splice(0, 0, ''));
  }

  const lastCell = middleCells.pop();

  return [firstCell, middleCells, lastCell] as const;
}